
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"17","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8 5.643V3.928M6.286 10.214c0 .857.765 1.143 1.714 1.143.948 0 1.714 0 1.714-1.143 0-1.714-3.428-1.714-3.428-3.429 0-1.142.765-1.142 1.714-1.142.948 0 1.714.434 1.714 1.142M8 11.357v1.714","stroke":"#56BFC7","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M8 15.928A7.429 7.429 0 108 1.071a7.429 7.429 0 000 14.857z","stroke":"#56BFC7","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    